"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var format_1 = __importDefault(require("date-fns/format"));
var utils_1 = require("./utils");
var add_1 = __importDefault(require("material-ui/svg-icons/content/add"));
var clear_1 = __importDefault(require("material-ui/svg-icons/content/clear"));
var delete_1 = __importDefault(require("material-ui/svg-icons/action/delete"));
var search_1 = __importDefault(require("material-ui/svg-icons/action/search"));
var IconButton_1 = __importDefault(require("../IconButton"));
var Select_1 = __importDefault(require("../Select"));
var DateTime_1 = __importDefault(require("../DateTime"));
var NumberInput_1 = __importDefault(require("../NumberInput"));
var Input_1 = __importDefault(require("../Input"));
var AutoCompleteRemoteFilter_1 = __importDefault(require("../AutoCompleteRemoteFilter"));
var utils_2 = require("./utils");
var constants_1 = require("./constants");
var debounced_1 = __importDefault(require("../debounced"));
var operationIsNull = constants_1.FilterOperation.IS_NULL;
var operationNotNull = constants_1.FilterOperation.NOT_NULL;
var columnFunction = function (_a) {
    var field = _a.field;
    return field;
};
var operationFunction = function (_a) {
    var id = _a.id;
    return id;
};
var booleanFunction = function (_a) {
    var id = _a.id;
    return id;
};
var enumFunction = function (_a) {
    var id = _a.id;
    return id;
};
var inlineStyle = {
    display: 'inline-block',
};
var FilterValueBase = function (_a) {
    var column = _a.column, value = _a.value, label = _a.label, onFilterValueChange = _a.onFilterValueChange, onKeyPress = _a.onKeyPress, style = _a.style, locale = _a.locale, inputStyle = _a.inputStyle, disabled = _a.disabled, setFocusedField = _a.setFocusedField, focusedField = _a.focusedField, type = _a.type, id = _a.id, dateTimeInISO = _a.dateTimeInISO, noCompact = _a.noCompact, rest = __rest(_a, ["column", "value", "label", "onFilterValueChange", "onKeyPress", "style", "locale", "inputStyle", "disabled", "setFocusedField", "focusedField", "type", "id", "dateTimeInISO", "noCompact"]);
    var textInput = react_1.default.createRef();
    react_1.default.useEffect(function () {
        if (!disabled && column && focusedField === column.field) {
            textInput.current && textInput.current.focus();
        }
    }, // `{}` the brackets are important to prevent implicit return
    [disabled]);
    var handleDialogClose = id
        ? function () {
            setTimeout(function () {
                var element = document.getElementById(id + "-input");
                if (element) {
                    element.focus();
                }
            });
        }
        : undefined;
    switch (type) {
        case constants_1.ColumnType.NUMBER:
            return (react_1.default.createElement(NumberInput_1.default, { style: style, label: label, value: value, onChange: onFilterValueChange, onKeyPress: onKeyPress, inputStyle: inputStyle, id: id, name: "number" }));
        case constants_1.ColumnType.TEXT:
            return (react_1.default.createElement(Input_1.default, { style: style, label: label, value: value, onChange: onFilterValueChange, onKeyPress: onKeyPress, inputStyle: inputStyle, id: id, name: "text", inputRef: textInput, disabled: disabled, onFocus: function () { return setFocusedField(column.field); }, onBlur: function () { return setFocusedField(undefined); } }));
        case constants_1.ColumnType.TEXT_NUMBER:
            return (react_1.default.createElement(Input_1.default, { style: style, label: label, value: value, onChange: onFilterValueChange, onKeyPress: onKeyPress, inputStyle: inputStyle, id: id, name: "textNumber", inputRef: textInput, disabled: disabled, onFocus: function () { return setFocusedField(column.field); }, onBlur: function () { return setFocusedField(undefined); } }));
        case constants_1.ColumnType.DATE:
            return (react_1.default.createElement("div", { style: inlineStyle },
                react_1.default.createElement(DateTime_1.default, __assign({ locale: locale === 'en' ? 'en-US' : 'cs-CZ', style: style, value: value, onChange: onFilterValueChange, onKeyPress: onKeyPress, id: id, name: "date", dateOnly: true, disabled: disabled, compact: column.compact, onDialogClose: handleDialogClose }, rest))));
        case constants_1.ColumnType.DATETIME:
        case constants_1.ColumnType.DATETIMEWITHOUTZONE:
            return (react_1.default.createElement("div", { style: inlineStyle },
                react_1.default.createElement(DateTime_1.default, __assign({ locale: locale === 'en' ? 'en-US' : 'cs-CZ', style: style, value: value, onChange: onFilterValueChange, onKeyPress: onKeyPress, id: id, name: "dateTime", disabled: disabled, compact: noCompact ? false : column.compact, onDialogClose: handleDialogClose, dateTimeInISO: dateTimeInISO }, rest))));
        case constants_1.ColumnType.ENUM:
            return (react_1.default.createElement(Select_1.default, { style: style, items: column.enum, label: label, value: value, valueFunction: enumFunction, onChange: onFilterValueChange, id: id, name: "enum", disabled: disabled }));
        case constants_1.ColumnType.REMOTE_ENUM:
            return (react_1.default.createElement(AutoCompleteRemoteFilter_1.default, { style: style, label: label, value: value, url: column.url, doPost: column.doPost, params: column.params, filterField: column.filterField, valueFunction: column.valueFunction, labelFunction: column.labelFunction, onChange: onFilterValueChange, id: id, name: "remoteEnum", disabled: disabled }));
        case constants_1.ColumnType.BOOLEAN:
            return (react_1.default.createElement(Select_1.default, { style: style, items: rest.booleanTranslation, label: label, valueFunction: booleanFunction, value: value, onChange: onFilterValueChange, id: id, name: "boolean", disabled: disabled }));
        case constants_1.ColumnType.JSX:
            if (column.filterComponent) {
                return react_1.default.createElement(column.filterComponent, __assign({ name: 'text', id: 'jsx', style: style,
                    value: value,
                    label: label, onChange: onFilterValueChange, onKeyPress: onKeyPress,
                    disabled: disabled, onFocus: function () { return setFocusedField(column.field); }, onBlur: function () { return setFocusedField(undefined); } }, column.filterComponentProps));
            }
            return null;
        default:
            return null;
    }
};
exports.FilterValue = recompose_1.compose(recompose_1.defaultProps({ setFocusedField: lodash_1.noop }), recompose_1.mapProps(function (_a) {
    var filter = _a.filter, rest = __rest(_a, ["filter"]);
    return (__assign({ value: filter.value }, rest));
}), recompose_1.withState('valueOnEnter', 'setValueOnEnter', function (_a) {
    var value = _a.value;
    return value;
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (newProps) {
        var value = newProps.value;
        var _a = this.props, oldValue = _a.value, setValueOnEnter = _a.setValueOnEnter;
        if (value !== oldValue) {
            setValueOnEnter(value);
        }
    },
}), recompose_1.withHandlers({
    onFilterValueChangeOnEnter: function (_a) {
        var setValueOnEnter = _a.setValueOnEnter;
        return function (value) {
            setValueOnEnter(value);
        };
    },
}), recompose_1.withHandlers({
    onKeyPress: function (_a) {
        var onFilterValueChange = _a.onFilterValueChange, valueOnEnter = _a.valueOnEnter, value = _a.value;
        return function (e) {
            if (e.key === 'Enter' && (value !== undefined || valueOnEnter !== undefined)) {
                onFilterValueChange(valueOnEnter);
            }
        };
    },
}), recompose_1.withProps(function (_a) {
    var onFilterValueChange = _a.onFilterValueChange;
    return ({
        onFilterValueChangeDebounced: onFilterValueChange,
    });
}), debounced_1.default('value', 'onFilterValueChangeDebounced', 1000), recompose_1.withHandlers({
    onDateOrDateTimeFilterValueChange: function (_a) {
        var onFilterValueChangeDebounced = _a.onFilterValueChangeDebounced, onFilterValueChange = _a.onFilterValueChange;
        return function (value, type) {
            if (type === 'TEXT') {
                onFilterValueChangeDebounced(value);
            }
            else {
                onFilterValueChange(value);
            }
        };
    },
    onDateOrDateTimeFilterValueChangeOnEnter: function (_a) {
        var column = _a.column, onFilterValueChangeOnEnter = _a.onFilterValueChangeOnEnter, onFilterValueChange = _a.onFilterValueChange;
        return function (value, type) {
            if (type === 'TEXT' || !column.compact) {
                onFilterValueChangeOnEnter(value);
            }
            else {
                onFilterValueChange(value);
            }
        };
    },
}), recompose_1.withProps(function (_a) {
    var column = _a.column;
    return ({
        type: column ? column.type : null,
    });
}), recompose_1.withProps(function (_a) {
    var type = _a.type;
    return ({
        isSelect: type === constants_1.ColumnType.ENUM || type === constants_1.ColumnType.REMOTE_ENUM || type === constants_1.ColumnType.BOOLEAN,
        isDateOrDateTime: type === constants_1.ColumnType.DATE || type === constants_1.ColumnType.DATETIME || type === constants_1.ColumnType.DATETIMEWITHOUTZONE,
    });
}), recompose_1.withProps(function (_a) {
    var changeFilterValueOnEnter = _a.changeFilterValueOnEnter, type = _a.type, isDateOrDateTime = _a.isDateOrDateTime;
    return ({
        onEnter: changeFilterValueOnEnter &&
            (type === constants_1.ColumnType.NUMBER || type === constants_1.ColumnType.TEXT || type === constants_1.ColumnType.TEXT_NUMBER || isDateOrDateTime),
    });
}), recompose_1.withProps(function (_a) {
    var onFilterValueChange = _a.onFilterValueChange, onKeyPress = _a.onKeyPress, onFilterValueChangeOnEnter = _a.onFilterValueChangeOnEnter, onFilterValueChangeDebounced = _a.onFilterValueChangeDebounced, onDateOrDateTimeFilterValueChange = _a.onDateOrDateTimeFilterValueChange, onDateOrDateTimeFilterValueChangeOnEnter = _a.onDateOrDateTimeFilterValueChangeOnEnter, value = _a.value, valueOnEnter = _a.valueOnEnter, onEnter = _a.onEnter, isDateOrDateTime = _a.isDateOrDateTime, isSelect = _a.isSelect;
    return ({
        onFilterValueChange: onEnter
            ? isDateOrDateTime
                ? onDateOrDateTimeFilterValueChangeOnEnter
                : onFilterValueChangeOnEnter
            : isDateOrDateTime
                ? onDateOrDateTimeFilterValueChange
                : isSelect
                    ? onFilterValueChange
                    : onFilterValueChangeDebounced,
        onKeyPress: onEnter ? onKeyPress : undefined,
        value: onEnter ? valueOnEnter : value,
    });
}), recompose_1.mapProps(function (_a) {
    var valueOnEnter = _a.valueOnEnter, setValueOnEnter = _a.setValueOnEnter, onFilterValueChangeOnEnter = _a.onFilterValueChangeOnEnter, changeFilterValueOnEnter = _a.changeFilterValueOnEnter, onEnter = _a.onEnter, isDateOrDateTime = _a.isDateOrDateTime, isSelect = _a.isSelect, onFilterValueChangeDebounced = _a.onFilterValueChangeDebounced, onDateOrDateTimeFilterValueChange = _a.onDateOrDateTimeFilterValueChange, onDateOrDateTimeFilterValueChangeOnEnter = _a.onDateOrDateTimeFilterValueChangeOnEnter, rest = __rest(_a, ["valueOnEnter", "setValueOnEnter", "onFilterValueChangeOnEnter", "changeFilterValueOnEnter", "onEnter", "isDateOrDateTime", "isSelect", "onFilterValueChangeDebounced", "onDateOrDateTimeFilterValueChange", "onDateOrDateTimeFilterValueChangeOnEnter"]);
    return (__assign({}, rest));
}))(FilterValueBase);
var Filter = function (_a) {
    var filter = _a.filter, filters = _a.filters, columns = _a.columns, styles = _a.styles, onRemoveFilterClick = _a.onRemoveFilterClick, onFilterColumnChange = _a.onFilterColumnChange, onFilterOperationChange = _a.onFilterOperationChange, onFilterValueChange = _a.onFilterValueChange, columnLabel = _a.columnLabel, operationLabel = _a.operationLabel, valueLabel = _a.valueLabel, filterTranslations = _a.filterTranslations, booleanTranslation = _a.booleanTranslation, locale = _a.locale, changeFilterValueOnEnter = _a.changeFilterValueOnEnter, onFilterAggregationChange = _a.onFilterAggregationChange, index = _a.index, doPost = _a.doPost, allowNullFilter = _a.allowNullFilter, enableAggregation = _a.enableAggregation, dateTimeInISO = _a.dateTimeInISO;
    var field = filter.field, operation = filter.operation, aggregation = filter.aggregation;
    var column = columns.find(function (c) { return columnFunction(c) === field; });
    var allowedOperations = column
        ? column.type === constants_1.ColumnType.JSX
            ? column.filterOperations || []
            : constants_1.filterOperations[column.type]
        : [];
    var filterObjects = allowedOperations.map(function (op) { return ({
        id: op,
        label: filterTranslations[op],
    }); });
    if (field && allowNullFilter) {
        filterObjects.push({
            id: operationIsNull,
            label: filterTranslations[operationIsNull],
        });
        filterObjects.push({
            id: operationNotNull,
            label: filterTranslations[operationNotNull],
        });
    }
    var filteredColumns = columns.filter(function (c) { return c.type !== constants_1.ColumnType.JSX || !lodash_1.isEmpty(c.filterOperations); });
    var previousFilter = filters[index - 1];
    var isPreviousSameField = previousFilter ? previousFilter.field === filter.field : false;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        enableAggregation && doPost && index > 0 && isPreviousSameField && (react_1.default.createElement("li", null,
            react_1.default.createElement(Select_1.default, { id: "uas-web-core-grid-filter-aggregation-" + index + "-" + field, style: styles.filterAggregation, label: 'Agregace', items: constants_1.aggregationOptions, valueFunction: operationFunction, value: aggregation, onChange: function (value) { return onFilterAggregationChange(value, index); } }))),
        react_1.default.createElement("li", { id: "uas-web-core-grid-filter-row", "data-type": index + "-" + field, style: styles.filterRow },
            react_1.default.createElement(IconButton_1.default, { style: styles.filterRowRemove, onClick: onRemoveFilterClick },
                react_1.default.createElement(clear_1.default, null)),
            react_1.default.createElement(Select_1.default, { id: "uas-web-core-grid-filter-column-" + index + "-" + field, style: styles.filterRowColumn, label: columnLabel, valueFunction: columnFunction, items: filteredColumns, value: field, onChange: function (value) { return onFilterColumnChange(value, index); } }),
            react_1.default.createElement(Select_1.default, { id: "uas-web-core-grid-filter-operation-" + index + "-" + field, style: styles.filterRowOperation, label: operationLabel, valueFunction: operationFunction, items: filterObjects, value: operation, onChange: onFilterOperationChange }),
            operation !== operationIsNull && operation !== operationNotNull && (react_1.default.createElement(exports.FilterValue, { id: "uas-web-core-grid-filter-value-" + index + "-" + field, locale: locale, style: styles.filterRowValue, filter: filter, column: column, label: valueLabel, onFilterValueChange: onFilterValueChange, booleanTranslation: booleanTranslation, changeFilterValueOnEnter: changeFilterValueOnEnter, dateTimeInISO: dateTimeInISO, noCompact: true })))));
};
var FilterComposed = recompose_1.compose(recompose_1.pure, utils_2.withStyles, recompose_1.withHandlers({
    onRemoveFilterClick: function (_a) {
        var filter = _a.filter, filters = _a.filters, setFilters = _a.setFilters;
        return function () {
            setFilters(filters.filter(function (f) { return f !== filter; }));
        };
    },
    onFilterColumnChange: function (_a) {
        var filter = _a.filter, filters = _a.filters, setFilters = _a.setFilters, enableAggregation = _a.enableAggregation;
        return function (value, index) {
            var previous = filters[index - 1];
            var isPreviousSameField = previous && previous.field === value;
            var newFilter = __assign({}, filter, { field: value, operation: null, value: '', aggregation: enableAggregation && isPreviousSameField ? 'OR' : null });
            filters = filters.map(function (f, i) {
                return enableAggregation && i === index - 1 && f.field === value
                    ? __assign({}, f, { aggregation: 'OR' }) : f;
            });
            setFilters(utils_1.replace(filters, filter, newFilter));
        };
    },
    onFilterOperationChange: function (_a) {
        var filter = _a.filter, filters = _a.filters, setFilters = _a.setFilters;
        return function (value) {
            var newFilter = __assign({}, filter, { operation: value });
            if (value === operationIsNull || value === operationNotNull) {
                newFilter.value = true;
            }
            setFilters(utils_1.replace(filters, filter, newFilter));
        };
    },
    onFilterValueChange: function (_a) {
        var filter = _a.filter, filters = _a.filters, setFilters = _a.setFilters;
        return function (value) {
            var newFilter = __assign({}, filter, { value: value });
            setFilters(utils_1.replace(filters, filter, newFilter));
        };
    },
    onFilterAggregationChange: function (_a) {
        var filter = _a.filter, filters = _a.filters, setFilters = _a.setFilters, enableAggregation = _a.enableAggregation;
        return function (value, index) {
            var newFilter = enableAggregation
                ? __assign({}, filter, { aggregation: value }) : filter;
            filters = filters.map(function (f, i) {
                return enableAggregation && i === index - 1
                    ? __assign({}, f, { aggregation: value }) : f;
            });
            setFilters(utils_1.replace(filters, filter, newFilter));
        };
    },
}))(Filter);
var Filters = function (_a) {
    var filters = _a.filters, filtersLabel = _a.filtersLabel, styles = _a.styles, onAddFilterClick = _a.onAddFilterClick, onRemoveAllFiltersClick = _a.onRemoveAllFiltersClick, doPost = _a.doPost, onSearchFiltersClick = _a.onSearchFiltersClick, rest = __rest(_a, ["filters", "filtersLabel", "styles", "onAddFilterClick", "onRemoveAllFiltersClick", "doPost", "onSearchFiltersClick"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: styles.filtersCaption },
            react_1.default.createElement("span", { style: styles.filtersTitle }, filtersLabel),
            react_1.default.createElement(IconButton_1.default, { style: styles.filtersAdd, onClick: onAddFilterClick },
                react_1.default.createElement(add_1.default, null)),
            react_1.default.createElement(IconButton_1.default, { style: styles.filtersRemoveAll, onClick: onRemoveAllFiltersClick },
                react_1.default.createElement(delete_1.default, null)),
            react_1.default.createElement(IconButton_1.default, { style: styles.filtersSearchAll, onClick: onSearchFiltersClick },
                react_1.default.createElement(search_1.default, null))),
        react_1.default.createElement("ul", { style: styles.filters }, filters.map(function (filter, i) { return (react_1.default.createElement(FilterComposed, __assign({ key: "" + filter.field + i, filter: filter, filters: filters, index: i, doPost: doPost }, rest))); }))));
};
exports.default = recompose_1.compose(recompose_1.pure, utils_2.withStyles, recompose_1.withHandlers({
    onAddFilterClick: function (_a) {
        var filters = _a.filters, setFilters = _a.setFilters;
        return function () {
            var filter = {
                field: null,
                operation: null,
                value: '',
            };
            setFilters(__spread(filters, [filter]));
        };
    },
    onRemoveAllFiltersClick: function (_a) {
        var onRemoveAllFilters = _a.onRemoveAllFilters, setFilters = _a.setFilters, defaultFilter = _a.defaultFilter;
        return function () {
            onRemoveAllFilters();
            if (typeof defaultFilter !== 'undefined') {
                setFilters(defaultFilter);
            }
            else {
                setFilters([]);
            }
        };
    },
    onSearchFiltersClick: function (_a) {
        var filters = _a.filters, setFilters = _a.setFilters, columns = _a.columns, booleanTranslation = _a.booleanTranslation;
        return function () {
            try {
                var rows = document.querySelectorAll('li[id="uas-web-core-grid-filter-row"], li[data-type]');
                var result_1 = [];
                Array.from(rows).forEach(function (row) {
                    var dataType = row.getAttribute('data-type') || '';
                    var dashIndex = dataType.indexOf('-');
                    var field = dashIndex !== -1 ? dataType.substring(dashIndex + 1) : undefined;
                    var valueEl = document.getElementById("uas-web-core-grid-filter-value-" + dataType);
                    var operationEl = document.getElementById("uas-web-core-grid-filter-operation-" + dataType);
                    var aggregationEl = document.getElementById("uas-web-core-grid-filter-aggregation-" + dataType);
                    var getVal = function (el) {
                        if (!el)
                            return undefined;
                        try {
                            if ('value' in el)
                                return el.value;
                        }
                        catch (e) {
                            return undefined;
                        }
                        if (el.getAttribute)
                            return el.getAttribute('data-value') || el.textContent;
                        return el.textContent;
                    };
                    var aggOption = constants_1.aggregationOptions.find(function (_a) {
                        var label = _a.label;
                        return label === getVal(aggregationEl);
                    });
                    var operation = Object.keys(constants_1.filterTranslations).find(function (k) { return constants_1.filterTranslations[k] === getVal(operationEl); });
                    var aggregation = aggOption ? aggOption.id : null;
                    var value = null;
                    var column = columns.find(function (c) { return c.field === field; });
                    switch (column.type) {
                        case constants_1.ColumnType.REMOTE_ENUM:
                        case constants_1.ColumnType.JSX:
                            result_1.push(filters.find(function (f) { return f.field === field; }));
                            break;
                        case constants_1.ColumnType.ENUM:
                            var enumValue = column.enum.find(function (_a) {
                                var label = _a.label;
                                return label === getVal(valueEl);
                            });
                            value = enumValue ? enumValue.id : null;
                            result_1.push({ field: field, operation: operation, value: value, aggregation: aggregation });
                            break;
                        case constants_1.ColumnType.BOOLEAN:
                            var boolValue = booleanTranslation.find(function (_a) {
                                var label = _a.label;
                                return label === getVal(valueEl);
                            });
                            value = boolValue ? boolValue.id : null;
                            result_1.push({ field: field, operation: operation, value: value, aggregation: aggregation });
                            break;
                        case constants_1.ColumnType.DATE:
                            var pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4})/;
                            var dateValueElement = document.getElementById("uas-web-core-grid-filter-value-" + dataType + "-input");
                            var date = getVal(dateValueElement).replace(pattern, '$3-$2-$1');
                            value = format_1.default(date, 'YYYY-MM-DD');
                            result_1.push({ field: field, operation: operation, value: value, aggregation: aggregation });
                            break;
                        case constants_1.ColumnType.DATETIME:
                        case constants_1.ColumnType.DATETIMEWITHOUTZONE:
                            var pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4})\s?(\d{1,2}:\d{1,2})?/;
                            var dateValueElement = document.getElementById("uas-web-core-grid-filter-value-" + dataType + "-input");
                            var date = getVal(dateValueElement).replace(pattern, '$3-$2-$1T$4');
                            value = format_1.default(date, 'YYYY-MM-DDTHH:mm');
                            result_1.push({ field: field, operation: operation, value: value, aggregation: aggregation });
                            break;
                        default:
                            value = getVal(valueEl);
                            result_1.push({ field: field, operation: operation, value: value, aggregation: aggregation });
                    }
                });
                setFilters(result_1);
            }
            catch (err) {
                console.error('Error collecting filters from DOM:', err);
            }
        };
    },
}), recompose_1.mapProps(function (_a) {
    var onRemoveAllFilters = _a.onRemoveAllFilters, rest = __rest(_a, ["onRemoveAllFilters"]);
    return rest;
}))(Filters);
//# sourceMappingURL=Filters.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Filters.js
// module id = 957
// module chunks = 0